/**
 * Runtime feature flags read from Vite env vars at build time.
 *
 * Add new flags here (not scattered across components) so the flip
 * happens in one place. Backend flags of the same name live in
 * terraform/variables.tf — keep the semantics in sync.
 */

// v4.1 Sharing & Collaboration. Off by default; flipped to "on" after
// Phase 38 lands with comments + notifications. Backend (projects
// Lambda) is also gated by the `COLLAB_MODE` env var; having the
// client-side flag off additionally hides UI affordances so users
// don't see buttons that return 404.
export const COLLAB_MODE_ENABLED =
  (import.meta.env.VITE_COLLAB_MODE || "off").toLowerCase() === "on";
